"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class FeatureServiceLive {
    async isGenerallyAvailable(featureName) {
        const response = await HttpProvider_1.httpProvider.get(`/feature/${featureName}`);
        return response.data;
    }
}
exports.FeatureServiceLive = FeatureServiceLive;
//# sourceMappingURL=FeatureServiceLive.js.map